import {
    CREATE_BUSINESS_ADDON_REQUEST,
    CREATE_BUSINESS_ADDON_SUCCESS,
    CREATE_BUSINESS_ADDON_FAILURE,
    GET_BUSINESS_ADDONS_REQUEST,
    GET_BUSINESS_ADDONS_SUCCESS,
    GET_BUSINESS_ADDONS_FAILURE,
    UPDATE_BUSINESS_ADDON_REQUEST,
    UPDATE_BUSINESS_ADDON_SUCCESS,
    UPDATE_BUSINESS_ADDON_FAILURE,
    DELETE_BUSINESS_ADDON_REQUEST,
    DELETE_BUSINESS_ADDON_SUCCESS,
    DELETE_BUSINESS_ADDON_FAILURE,
    CLEAR_BUSINESS_ADDON_ERROR,
    CLEAR_BUSINESS_ADDON_SUCCESS,
  } from '../actions/businessAddonActions';
  
  const initialState = {
    businessAddons: [],
    currentAddon: null, // For single addon operations
    loading: false,
    error: null,
    success: null,
  };
  
  const businessAddonReducer = (state = initialState, action) => {
    switch (action.type) {
      case CREATE_BUSINESS_ADDON_REQUEST:
      case GET_BUSINESS_ADDONS_REQUEST:
      case UPDATE_BUSINESS_ADDON_REQUEST:
      case DELETE_BUSINESS_ADDON_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
          success: null,
        };
  
      case CREATE_BUSINESS_ADDON_SUCCESS:
        return {
          ...state,
          loading: false,
          currentAddon: action.payload.data || action.payload,
          businessAddons: [...state.businessAddons, action.payload.data || action.payload],
          success: 'Business addon created successfully!',
        };
  
      case GET_BUSINESS_ADDONS_SUCCESS:
        // If payload is an array (multiple addons), update businessAddons
        // If payload is a single object, update currentAddon
        if (Array.isArray(action.payload)) {
          return {
            ...state,
            loading: false,
            businessAddons: action.payload,
            currentAddon: null, // Clear currentAddon if fetching a list
            success: 'Business addons fetched successfully!',
          };
        } else {
          return {
            ...state,
            loading: false,
            currentAddon: action.payload,
            // Update existing addon in the list if already present
            businessAddons: state.businessAddons.map(addon =>
              addon.id === action.payload.id ? action.payload : addon
            ),
            success: 'Business addon fetched successfully!',
          };
        }
  
      case UPDATE_BUSINESS_ADDON_SUCCESS:
        const updatedAddon = action.payload.data || action.payload;
        return {
          ...state,
          loading: false,
          currentAddon: updatedAddon,
          businessAddons: state.businessAddons.map((addon) =>
            addon.id === updatedAddon.id ? updatedAddon : addon
          ),
          success: 'Business addon updated successfully!',
        };
  
      case DELETE_BUSINESS_ADDON_SUCCESS:
        return {
          ...state,
          loading: false,
          businessAddons: state.businessAddons.filter(
            (addon) => addon.id !== action.payload
          ),
          currentAddon: state.currentAddon?.id === action.payload ? null : state.currentAddon,
          success: 'Business addon deleted successfully!',
        };
  
      case CREATE_BUSINESS_ADDON_FAILURE:
      case GET_BUSINESS_ADDONS_FAILURE:
      case UPDATE_BUSINESS_ADDON_FAILURE:
      case DELETE_BUSINESS_ADDON_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
          success: null,
        };
  
      case CLEAR_BUSINESS_ADDON_ERROR:
        return {
          ...state,
          error: null,
        };
  
      case CLEAR_BUSINESS_ADDON_SUCCESS:
        return {
          ...state,
          success: null,
        };
  
      default:
        return state;
    }
  };
  
  export default businessAddonReducer;